import firebase from "firebase/compat/app";

const setUserInfo = async function(userId, item) {
  let db = firebase.firestore();
  let result;
  if (userId != undefined) {
    result = await db
      .collection("wellness_users")
      .doc(userId)
      .set(item, { merge: true })
  }
  return result;
};

export default setUserInfo;
